import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import RequestMeeting from "@/pages/RequestMeeting";
import Grievance from "@/pages/Grievance";
import ShareIdeas from "@/pages/ShareIdeas";
import Volunteer from "@/pages/Volunteer";
import EventsPage from "@/pages/EventsPage";
import TrackRequest from "@/pages/TrackRequest";
import About from "@/pages/About";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/request-meeting" element={<RequestMeeting />} />
                    <Route path="/grievance" element={<Grievance />} />
                    <Route path="/share-ideas" element={<ShareIdeas />} />
                    <Route path="/volunteer" element={<Volunteer />} />
                    <Route path="/events" element={<EventsPage />} />
                    <Route path="/track" element={<TrackRequest />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/gallery" element={<GalleryPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                </Route>
            </Routes>
            <Toaster />
        </BrowserRouter>
    );
}

export default App;
